import React from 'react';

import { percentFigure } from '../../utils/percentFigure';

import { formatFigure, formatToFixedMoneyWithLocale } from 'Helpers/formatService';

import Tooltip from 'CommonComponents/Tooltip';

export default function ExpenseMilestoneFields(props) {
    const tooltipContent = () => {
        return props.expense && props.expense.currentMilestones[props.milestoneId] ? props.expense.currentMilestones[props.milestoneId].name : '';
    };

    const internalSetEditing = (milestone_index, type) => {
        if (props.canEdit && !props.isRowEditing) {
            return props.internalSetEditing(milestone_index, type);
        }
    };

    const handleDoubleClick = () => {
        if (!props.isRowEditing) {
            internalSetEditing(props.milestoneId, 'percentage');
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            const value = parseFloat(event.target.value);
            if (isNaN(value) || value === 0) {
                // If value is 0 or invalid, treat as deletion
                props.saveMilestonePercentage(event, props.milestoneId, true);
            } else {
                props.saveMilestonePercentage(event, props.milestoneId);
            }
        } else if (event.key === 'Escape') {
            props.closeChangeMilestone();
        }
    };

    // Row-level editing input handler
    const handleRowEditChange = (event) => {
        props.handleValueChange(props.milestoneId, event.target.value);
    };

    const hasMilestone =
        props.milestoneId in props.expense.currentMilestones &&
        props.expense.currentMilestones[props.milestoneId] &&
        props.expense.currentMilestones[props.milestoneId].percentage > 0;

    // Check if this cell should be in row editing mode
    const isInRowEditMode = props.isRowEditing;
    const currentEditValue =
        props.editedValues && props.editedValues[props.milestoneId] !== undefined
            ? props.editedValues[props.milestoneId]
            : hasMilestone
              ? (Number(props.expense.currentMilestones[props.milestoneId].percentage) * 100) / 100
              : '';

    // Calculate live amount during editing
    const getLiveAmount = () => {
        if (!isInRowEditMode || !props.totalUncommittedValue) return 0;

        const percentage = parseFloat(currentEditValue);
        if (isNaN(percentage) || percentage <= 0) return 0;

        return (props.totalUncommittedValue * percentage) / 100;
    };

    const liveAmount = isInRowEditMode ? getLiveAmount() : hasMilestone ? props.expense.currentMilestones[props.milestoneId].amount : 0;

    return (
        <>
            {/* Row editing mode */}
            {isInRowEditMode && (
                <td>
                    <input
                        type="number"
                        step="1"
                        name={`expense_${props.expense.id}_milestone_${props.milestoneId}_row_edit`}
                        className="tw-block tw-w-full tw-min-w-14 tw-rounded-lg tw-text-sm tw-bg-grey/25 -tw-my-1 tw-px-2 tw-py-1 tw-text-charcoal focus:tw-outline-0"
                        id={`expense_${props.expense.id}_milestone_${props.milestoneId}_row_edit`}
                        placeholder="Enter percentage"
                        value={currentEditValue}
                        onChange={handleRowEditChange}
                    />
                </td>
            )}

            {/* Individual cell editing mode */}
            {!isInRowEditMode &&
                (props.editingExpenseId != props.expense.id || props.editingType !== 'percentage' || props.editingMilestoneId != props.milestoneId) && (
                    <td className="tw-cursor-pointer tw-text-right">
                        {hasMilestone ? percentFigure(Math.round(Number(props.expense.currentMilestones[props.milestoneId].percentage) * 100) / 100) : ''}
                    </td>
                )}

            <td className="tw-text-right">
                <Tooltip placement="bottom-start" tooltipContent={tooltipContent()} backgroundClass="tw-bg-blue" tooltipType="text" allowTooltip={hasMilestone}>
                    <span>{formatFigure(liveAmount, formatToFixedMoneyWithLocale, { precision: 2 })}</span>
                </Tooltip>
            </td>
        </>
    );
}
